/* import __COLOCATED_TEMPLATE__ from './prescreener-category-step.hbs'; */
import Component from '@glimmer/component';

export default class RequestStepsPrescreenerCategoryStep extends Component {
  get label() {
    if (this.args.step?.index <= this.args.currentStep?.index) {
      return this.args.step.title;
    }
    return '';
  }
}
